
    import React from 'react';
    import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../../../../tools/webpack/svgSpriteLoader/icon.tsx";

    const symbol = new SpriteSymbol({
  "id": "like_20_light_I2BUu",
  "use": "like_20_light_I2BUu-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"like_20_light_I2BUu\">\n<defs>\n<linearGradient id=\"like_20_light_I2BUu_like_gradient_light_20\" x1=\"0\" y1=\"0\" x2=\"16\" y2=\"16\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#66ADFF\" />\n<stop offset=\"1\" stop-color=\"#0077FF\" />\n</linearGradient>\n</defs>\n<circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"url(#like_20_light_I2BUu_like_gradient_light_20)\" />\n<path d=\"M12.1992 6.5C13.7461 6.5 15 7.70487 15 9.19116C15 10.6921 14.3741 11.4447 11.7195 13.4286L10.5116 14.3313C10.2107 14.5562 9.78931 14.5562 9.48838 14.3313L8.2805 13.4286C5.62586 11.4447 5 10.6921 5 9.19116C5 7.70487 6.25394 6.5 7.80075 6.5C8.62949 6.5 9.35 6.9 10 7.65C10.65 6.9 11.3705 6.5 12.1992 6.5Z\" fill=\"white\" />\n</symbol>"
});
    sprite.add(symbol);

    const Like_20LightI2BUuSpriteSymbolComponent = props => {
      return React.createElement(SpriteSymbolComponent, {glyph: "like_20_light_I2BUu", width: 20, height: 20, ...props })
    }

    export { Like_20LightI2BUuSpriteSymbolComponent as ReactComponent };
  